<template>
  <div class="box">
    <div class="pointBox">
      <div class="item" v-for="(item,index) in pointLists" :key="index">
        <span>经度{{ item.longitude }}</span>
        <br/>
        <span>纬度{{ item.latitude }}</span>
        <Icon type="ios-close" @click="delPoint(index)"/>
      </div>
    </div>
    <Row>
      <Col :span="4"><Input v-model="addressName"></Input></Col>
      <Col :span="2">
        <Button type="primary" @click="getLngAndLat">搜搜</Button>
      </Col>
    </Row>
    <div id="pointMap"></div>
  </div>
</template>

<script>
export default {
  name: "pointMap",
  props: {
    pointLists: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map: null,
      addressName: '',
      pointList: []
    }
  },
  mounted() {
    this.initMap();
    if (this.pointLists.length > 0) {
      this.pointList = this.pointLists
    }
  },
  methods: {
    initMap() {
      this.map = new BMapGL.Map("pointMap");
      let point = new BMapGL.Point(
        116.36548487953385, 37.441680911700246);
      this.map.centerAndZoom(point, 15);
      this.map.enableScrollWheelZoom(true);
      // let cityCtrl = new BMapGL.CityListControl();  // 添加城市列表控件
      // this.map.addControl(cityCtrl);
      this.map.addEventListener("click", (e) => {
        console.log(e)
        this.pointLists.push({
          longitude: e.latlng.lng,
          latitude: e.latlng.lat,
          timeStamp: new Date().getTime()
        })
        // 点位
        let marker = new BMapGL.Marker(e.latlng);
        this.map.addOverlay(marker);
      });
    },
    // 在地图上添加
    addPoint() {
      this.pointLists.map(item => {
        console.log(item)
        let point = new BMapGL.Point(parseFloat(item.longitude), parseFloat(item.latitude));
        // let myIcon = new BMapGL.Icon(require("../../images/mapIcon/cangku.png"), new BMapGL.Size(20, 30), {
        //   // anchor: new BMapGL.Size(10, 25),
        //   // imageOffset: new BMapGL.Size(0, 0), // 设置图片偏移
        // });
        let marker = new BMapGL.Marker(point);
        this.map.addOverlay(marker);
      })

    },
    // 删除点位
    delPoint(index) {
      this.pointLists.splice(index, 1)
      // 删除地图上的点位
      this.map.removeOverlay(this.map.getOverlays()[index])
    },
    // 根据地址获取经纬度，并在地图上定位
    getLngAndLat() {
      let myGeo = new BMapGL.Geocoder();
      myGeo.getPoint(this.addressName, (point) => {
        if (point) {
          this.map.centerAndZoom(point, 16);
          this.map.addOverlay(new BMapGL.Marker(point));
        } else {
          alert("您选择地址没有解析到结果!");
        }
      }, "德州市");
    }
  }
}
</script>

<style scoped lang="less">
#pointMap {
  width: 100%;
  height: 500px;
}

.box {
  position: relative;

  .pointBox {
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    z-index: 999;
    background: #fff;
  }
}
</style>
